import { FilesState } from 'src/AppState/FilesState/FilesState';
import { FilesListCMSModelType } from 'src/api/config/filesCMS/getCMSFilesList';

export class FileItemComponentState {
    private readonly filesState: FilesState;
    private readonly file: FilesListCMSModelType;
    private readonly onChooseImage: (id: string) => void;
    private readonly onDeleteImage: (id: string) => void;

    constructor(
        filesState: FilesState,
        file: FilesListCMSModelType,
        onChooseImage: (id: string) => void,
        onDeleteImage: (id: string) => void
    ) {
        this.filesState = filesState;
        this.file = file;
        this.onChooseImage = onChooseImage;
        this.onDeleteImage = onDeleteImage;
    }

    handleChooseGame = (): void => {
        this.onChooseImage(this.file.media_link);
        this.filesState.handleHidePopup();
    };

    handleDeleteGame = (): void => {
        this.onDeleteImage(this.file.id);
    };
}
